import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { pnc, PncManipulationViewModel } from "./pncManipulation-viewModel"

export class PncManipulationView extends View<PncManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-D823ECBF-EE9E-4B9E-8AC9-223AE545D0F9"
    }
    loadHtml(): string {
        let element = require('./pncManipulation.html').default;
        let style = require('./pncManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set pncs(v: ObservableArray<pnc>) { this._pncs = v; } public get pncs(): ObservableArray<pnc> { return this._pncs;} private _pncs: ObservableArray<pnc>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    requestPncCreation(){
        this.dataContext.requestPncCreation();
    }
}
